import React from 'react';
import { FiDownload, FiLink, FiCpu } from 'react-icons/fi';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './EverythingYouNeed.css';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@shopify/polaris';

export default function EverythingYouNeed() {
  const navigate = useNavigate();
  const location = useLocation(); // Initialize useLocation

  // NEW FUNCTION: Implements "Go Back or Go Home" logic
  const handleBack = () => {
    // Check if it's likely the first route loaded in the session (key 'default')
    // or if the history is very short. If so, default to homepage ('/').
    if (location.key === 'default' || window.history.length <= 2) {
      navigate('/', { replace: true });
    } else {
      // Otherwise, safely go back one step in history
      navigate(-1);
    }
  };

  return (
    <section id="requirements" className="everything-you-need-section">
      {/* Back Button Section */}
      <div className="back-button-container">
      <Button
          onClick={handleBack} // UPDATED: Use the new handleBack function
          icon={<ArrowLeft size={16} />}
        >
        </Button>
      </div>

      <h2 className="section-title">Everything You’ll Need to Get BaoBrain Running</h2>

      <div className="setup-steps">
        {/* STEP 1 */}
        <div className="step-card">
          <div className="step-icon"><FiDownload size={36} /></div>
          <div className="step-content">
            <h3>1. Install BaoBrain</h3>
            <p>
              Click <strong>Install</strong> in your platform’s app store:<br />
              Find us on Shopify, BigCommerce, WooCommerce, or add our custom script
              to your site header. The install wizard takes less than 1 minute.
            </p>
          </div>
        </div>

        {/* STEP 2 */}
        <div className="step-card">
          <div className="step-icon"><FiLink size={36} /></div>
          <div className="step-content">
            <h3>2. Connect Google Analytics 4</h3>
            <p>
              Log in with Google and choose your GA4 property. <br/>
              <Link to="/InstallationGuide" className="inline-link">
                Need help creating GA4? See our installation guide ↗
              </Link>
            </p>
          </div>
        </div>

        {/* STEP 3 */}
        <div className="step-card">
          <div className="step-icon"><FiCpu size={36} /></div>
          <div className="step-content">
            <h3>3. Inject the Tracking Script</h3>
            <p>
              At the end of your account flow, click
              <strong> “Inject Tracking Script.”</strong> We’ll add one lightweight
              snippet—no coding required—and you’re live!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
